import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';
import { BaseService, Page, } from 'yellowfin-ui-lib';
import { Count } from 'yellowfin-ui-lib';
import { Product, ProductPage, ProductsSearch, Taxonomy } from 'yf-commerce-model-ui-lib';

export class CatalogService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getMenu(): Promise<Taxonomy[]> {
		return this.mapResponse(this.http.get(`/ws/catalog/taxo/menu`), Taxonomy);
	}

	search(search: ProductsSearch, page: Page): Promise<Product[]> {
		return this.mapResponse(this.http.post(`/ws/catalog/search/${page.start}/${page.stop}`, classToPlain(search)), Product);
	}

	searchCount(search: ProductsSearch): Promise<Count> {
		return this.mapResponse(this.http.post(`/ws/catalog/count`, classToPlain(search)), Count);
	}

	getTaxonomyBySlug(slug: string): Promise<Taxonomy> {
		return this.mapResponse(this.http.get(`/ws/catalog/taxo/route/${slug}`), Taxonomy);
	}

	getProductBySlug(slug: string): Promise<ProductPage> {
		return this.mapResponse(this.http.get(`/ws/catalog/product/${slug}`), ProductPage);
	}

}
